import { render, staticRenderFns } from "./BasicTypeahead.vue?vue&type=template&id=540a4dfe&"
import script from "./BasicTypeahead.vue?vue&type=script&lang=js&"
export * from "./BasicTypeahead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports